import React from "react";
import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { CommonButton } from "../common/commonButton";
import { ViewGenericWorkflowDialog } from "./ViewGenericWorkflowDialog";
import WorkStep from "./WorkStep";

const CloseIconStyle = {
  backgroundColor: "#3B3F44",
  color: "#ffff",
  height: "16px",
  width: "16px",
  padding: "7px 8px",
  borderRadius: "32px",
};

const UpdateGenericWorkflowDialog = ({
  openUpdateGenericWorkflowDialog,
  handleUpdateGenericWorkflowDialog,
  workflowName,
  currentWorkflowDetails,
  workflowTxnData,
}) => {
  
  const handleClose = () => handleUpdateGenericWorkflowDialog(false);

  return (
    <Dialog
      open={openUpdateGenericWorkflowDialog}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "900px",
          maxWidth: "90vw",
          backgroundColor: "#FFFFFF",
          "&::-webkit-scrollbar": {
            display: "none",
          },
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        },
      }}
    >
      <Box sx={{ backgroundColor: "#FFFFFF", position: "relative" }}>
        {/* CLOSE ICON */}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: "absolute", right: 10, top: 20 }}
        >
          <CloseIcon style={CloseIconStyle} />
        </IconButton>
        <DialogContent sx={{ padding: 0 }}>
          <WorkStep
            workflowTxnData={workflowTxnData}
            workflowSelectedName={workflowName}
            currentWorkflowDetails={currentWorkflowDetails}
            onClose={handleClose}
          />
        </DialogContent>
        {/* FOOTER */}
        <Box
          sx={{
            p: 2,
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
          }}
        >
          <CommonButton
            text="Cancel"
            handleClick={handleClose}
            sx={{
              backgroundColor: "#fff",
              color: "#000",
              border: "1px solid #BCBDBF",
            }}
          />
        </Box>
      </Box>
    </Dialog>
  );
};

export default UpdateGenericWorkflowDialog;